import { useState } from 'react';

import type {
  GetFamilyEventDetailsOfSmsPath,
  GetFamilyEventDetailsOfSmsQuery,
} from '@src/api/event/getFamilyEventDetailsOfSms';
import { useInfiniteQuery } from 'react-query';

import { getFamilyEventDetailsOfSms } from '@api/event';

function useGetFamilyEventDetailsOfSms({
  eventId,
  ...props
}: Partial<GetFamilyEventDetailsOfSmsQuery> & GetFamilyEventDetailsOfSmsPath) {
  const [total, setTotal] = useState<number>(0);

  const response = useInfiniteQuery(
    ['FAMILY_EVENTS_DETAILS_OF_SMS', eventId, props?.page, props?.dir, props?.q],
    async ({ pageParam: page = 1 }) => {
      const query: GetFamilyEventDetailsOfSmsQuery = {
        page,
        limit: 100,
        dir: 'desc',
        ...props,
      };

      const response = await getFamilyEventDetailsOfSms({ path: { eventId }, query });

      console.log({ response });

      if (response) setTotal(response.count);

      return response;
    },
    {
      getNextPageParam: (_, pageParam) => {
        const result = pageParam.length + 1;
        return result;
      },
      getPreviousPageParam: (_, pageParam) => {
        const result = pageParam.length - 1;
        return result || 1;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: 1,
    },
  );

  const data =
    response.data?.pages?.filter(v => v)?.flatMap(data => (data ? data?.rows?.map(v => v) : [])) ||
    [];

  return { ...response, data, total };
}

export default useGetFamilyEventDetailsOfSms;
